import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import {
    BlockType,
    CodeBlock,
    SettingType,
    TibboDataType,
    ValidationMessage,
    ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_38 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_38';
        this.name = 'Tibbit 38';

        const settings = [
            {
                id: 'BUTTON_NAME',
                name: 'Button Name',
                settingType: SettingType.NAME,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies() {
        const dependencies = [
            'kp',
        ];
        return dependencies;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        return blocks;
    }
}
